import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";
import { useSelector } from "react-redux";

// Async thunk for fetching follow-up tasks
export const fetchFollowUpTasks = createAsyncThunk(
  "messages/fetchFollowUpTasks",
  async (convoId, { rejectWithValue }) => {
    try {
      const response = await axiosClient.put(
        `message/listFollowUpTask/${convoId}`
      );
      const filteredTasks = response.data.Data.filter(
        (task) => task.followupStatus !== "DELETED"
      );
      return filteredTasks;
    } catch (error) {
      console.error("Error fetching follow-up tasks:", error);
      return rejectWithValue(error.response?.data || "Failed to fetch tasks");
    }
  }
);
export const fetchConvoById = createAsyncThunk(
  "messages/Conversations",
  async ({ params, userId, isAdmin }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `message/getChildConversationMessage`,
        { params }
      );
      const filterNonScheduled = response.data.ChildData.filter(
        (msg) =>
          msg.createdBy === userId ||
          isAdmin ||
          (msg.messageStatus !== 0 && msg.messageStatus !== 14)
      );
      return {
        data: filterNonScheduled,
        parent: response.data.ParentData[0],
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch conversation"
      );
    }
  }
);

const initialState = {
  convos: [],
  // finalConvos: [],
  messageText: "",
  temps: [],
  selectedConvo: null,
  selectedConvoId: null,
  messages: [],
  messagesLoading: false,
  messagesError: null,
  loadingNotif: false,
  myConnections: [],
  myJobOffers: [],
  selectedFile: null,
  lodingConvo: false,
  sendingFile: false,
  sendingMsg: false,
  searchTerm: "",
  meetingDateSearch: "",
  eventDateSearch: "",
  eventMonthsearch: "",
  unreadSearch: false,
  guestCount: null,
  description: "",
  order: null,
  orderStatus: "",
  newMessage: null,
  childId: null,
  oppertunity: 0,
  invoiceItemsToDisplay: [],
  invoiceCreatedPackages: [],
  invoiceOptions: [],
  newItemsToDisplay: [],
  newCreatedPackages: [],
  newOptions: [],
  selectedPackage: {},
  selectedPackagePrice: null,
  oppertunityFilter: null,
  showFollowUp: false,
  oppertunityStage: false,
  selectedPackages: {},
  paypalResponse: "",
  image: null,
  lightbox: false,
  typingStatus: "",
  openAllFollowUp: false,
  allFollowUpTasks: [],
  followUpTasksLoading: false, // Added to track loading state
  followUpTasksError: null, // Added to track errors
  showAvailability: false,
};

const MessagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    resetMessagesState: (state) => initialState,
    setConversations: (state, action) => {
      state.convos = action.payload;
    },
    // setFinalConvos: (state, action) => {
    //   state.finalConvos = action.payload;
    // },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setMeetingDateSearch: (state, action) => {
      state.meetingDateSearch = action.payload;
    },
    setEventDateSearch: (state, action) => {
      state.eventDateSearch = action.payload;
    },
    setEventMonthsearch: (state, action) => {
      state.eventMonthsearch = action.payload;
    },
    setUnreadSearch: (state, action) => {
      state.unreadSearch = action.payload;
    },
    setGuestCount: (state, action) => {
      state.guestCount = action.payload;
    },
    setMessageText: (state, action) => {
      state.messageText = action.payload;
    },
    setTemps: (state, action) => {
      state.temps = action.payload;
    },
    setShowAvailability: (state, action) => {
      state.showAvailability = action.payload;
    },
    // In MsgSlice.js
    setSelectedConversation: (state, action) => {
      const newConvo = action.payload;
      if (JSON.stringify(state.selectedConvo) !== JSON.stringify(newConvo)) {
        state.selectedConvo = newConvo;
      }
    },
    setSelectedConvoId: (state, action) => {
      state.selectedConvoId = action.payload;
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    setLoadingNotif: (state, action) => {
      state.loadingNotif = action.payload;
    },
    setMyConnections: (state, action) => {
      state.myConnections = action.payload;
    },
    setMyJobOffers: (state, action) => {
      state.myJobOffers = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },
    setLodingConvo: (state, action) => {
      state.lodingConvo = action.payload;
    },
    setSendingFile: (state, action) => {
      state.sendingFile = action.payload;
    },
    setSendingMsg: (state, action) => {
      state.sendingMsg = action.payload;
    },
    setDescription: (state, action) => {
      state.description = action.payload;
    },
    setOrder: (state, action) => {
      state.order = action.payload;
    },
    setOrderStatus: (state, action) => {
      state.orderStatus = action.payload;
    },
    setNewMessage: (state, action) => {
      state.newMessage = action.payload;
    },
    setChildId: (state, action) => {
      state.childId = action.payload;
    },
    setOppertunity: (state, action) => {
      state.oppertunity = action.payload;
    },
    setInvoiceItemsToDisplay: (state, action) => {
      state.invoiceItemsToDisplay = action.payload;
    },
    setInvoiceCreatedPackages: (state, action) => {
      state.invoiceCreatedPackages = action.payload;
    },
    setInvoiceOptions: (state, action) => {
      state.invoiceOptions = action.payload;
    },
    setNewItemsToDisplay: (state, action) => {
      state.newItemsToDisplay = action.payload;
    },
    setNewCreatedPackages: (state, action) => {
      state.newCreatedPackages = action.payload;
    },
    setNewOptions: (state, action) => {
      state.newOptions = action.payload;
    },
    setOppertunityFilter: (state, action) => {
      state.oppertunityFilter = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    setSelectedPrice: (state, action) => {
      state.selectedPackagePrice = action.payload;
    },
    setShowFollowUp: (state, action) => {
      state.showFollowUp = action.payload;
    },
    setOppertunityStage: (state, action) => {
      state.oppertunityStage = action.payload;
    },
    setSelectedPackages: (state, action) => {
      state.selectedPackages = action.payload;
    },
    setPaypalResponse: (state, action) => {
      state.paypalResponse = action.payload;
    },
    setImage: (state, action) => {
      state.image = action.payload;
    },
    setLightbox: (state, action) => {
      state.lightbox = action.payload;
    },
    setTypingStatus: (state, action) => {
      state.typingStatus = action.payload;
    },
    setOpenAllFollowUp: (state, action) => {
      state.openAllFollowUp = action.payload;
    },
    setAllFollowUpTasks: (state, action) => {
      state.allFollowUpTasks = action.payload;
    },
    // MsgSlice.js  (add inside reducers)
    addIncomingMessage: (state, action) => {
      const incoming = action.payload;
      // Defensive: make sure we have a real message
      if (!incoming || typeof incoming !== "object") return;
      // Ensure messages is always an array
      const current = Array.isArray(state.messages) ? state.messages : [];
      // Use a reliable unique identifier
      const messageId = incoming.Id ?? incoming.id ?? incoming.tempId;
      if (!messageId) {
        // If no ID at all → just append (rare edge case)
        state.messages = [incoming, ...current];
        return;
      }
      // Prevent duplicates
      const exists = current.some((m) => {
        const existingId = m.Id ?? m.id ?? m.tempId;
        return existingId === messageId;
      });
      if (exists) return;
      // Append the new message
      state.messages = [incoming, ...current];
    },
    updateSelectedConvoFields: (state, action) => {
      const updates = action.payload;
      if (state.selectedConvo && typeof updates === "object") {
        state.selectedConvo = {
          ...state.selectedConvo,
          ...updates,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFollowUpTasks.pending, (state) => {
        state.followUpTasksLoading = true;
        state.followUpTasksError = null;
      })
      .addCase(fetchFollowUpTasks.fulfilled, (state, action) => {
        state.followUpTasksLoading = false;
        state.allFollowUpTasks = action.payload;
      })
      .addCase(fetchFollowUpTasks.rejected, (state, action) => {
        state.followUpTasksLoading = false;
        state.followUpTasksError = action.payload || "Failed to fetch tasks";
      })
      .addCase(fetchConvoById.pending, (state) => {
        state.lodingConvo = true;
        state.messagesError = null;
      })
      .addCase(fetchConvoById.fulfilled, (state, action) => {
        state.lodingConvo = false;
        state.messages = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.selectedConvo = action.payload.parent;
      })
      .addCase(fetchConvoById.rejected, (state, action) => {
        state.lodingConvo = false;
        state.messagesError = action.payload || "Failed to fetch conversation";
        state.messages = [];
      });
  },
});

export const {
  resetMessagesState,
  setConversations,
  // setFinalConvos,
  setSearchTerm,
  setMeetingDateSearch,
  setEventDateSearch,
  setEventMonthsearch,
  setUnreadSearch,
  setGuestCount,
  setMessageText,
  setTemps,
  setSelectedConversation,
  setSelectedConvoId,
  setMessages,
  setLoadingNotif,
  setMyJobOffers,
  setMyConnections,
  setSelectedFile,
  setLodingConvo,
  setSendingFile,
  setSendingMsg,
  setDescription,
  setOrder,
  setOrderStatus,
  setNewMessage,
  setChildId,
  setOppertunity,
  setInvoiceItemsToDisplay,
  setInvoiceCreatedPackages,
  setInvoiceOptions,
  setNewCreatedPackages,
  setNewItemsToDisplay,
  setNewOptions,
  setOppertunityFilter,
  setSelectedPackage,
  setSelectedPrice,
  setShowFollowUp,
  setOppertunityStage,
  setSelectedPackages,
  setPaypalResponse,
  setImage,
  setLightbox,
  setTypingStatus,
  setOpenAllFollowUp,
  setAllFollowUpTasks,
  setShowAvailability,
  addIncomingMessage,
  updateSelectedConvoFields,
} = MessagesSlice.actions;

export default MessagesSlice.reducer;
// Correct way
// Correct way
export const fetchChild =
  (selectedConvoId, userId, isAdmin) => async (dispatch) => {
    const params = { parentId: selectedConvoId };
    return dispatch(
      fetchConvoById({
        params,
        userId,
        isAdmin,
      })
    );
  };
